import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom'

import NoPageFound from 'views/landing/noPageFound'

// auth
import authRoutes from './auth'
import AuthRoute from './auth/route'

// private
import privateRoutes from './private'
import PrivateRoute from './private/route'

const RoutesJSX = (
  
  <>
  
    {/* Auth routes */}
    {authRoutes.map((item) => (
      <Route
        key={item.path}
        path={item.path}
        exact
        element={<AuthRoute title={item.title} component={item.component} route={item.path} />}
      />
    ))}

    {/* Protected routes */}
    
    {privateRoutes.map((item) => (

      <Route
        key={item.path}
        path={item.path}
        exact
        element={
          <PrivateRoute
            title={item.title}
            component={item.component}
            route={item.path}
            permission={item.permission ?? []}
            screen_id={item.screen_id ?? null}
          />
        }
      />
    ))}

    {/* No page found */}
    <Route
      path='*'
      element={<AuthRoute title='No Page Found' component={NoPageFound} route='*' />}
    />
  </>
)

const routes = createRoutesFromElements(RoutesJSX)
const router = createBrowserRouter(routes)

export default function AppRouter() {
  return <RouterProvider router={router} />
}
